import { PrismicRichText } from "@prismicio/react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from 'react';
import { components } from "../../utils/rt-mods";
import VideoModal from "../videoModal";

export const VideoGrid = (props) => {

    const sc = props.slice.primary;

    const items = props.slice.items;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }


    let bg = sc.background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.background === "grey" ? "grey-light" : sc.background;

    

    return (
        <section className={"videos bg-" + (bg) + " " + (space)}>
            <div className="wrapper">
                    <div className="text-center w-full md:w-3/5 m-auto mb-12">
                        <PrismicRichText field={sc.section_title.richText} />
                        <PrismicRichText field={sc.section_content.richText} components={components} />
                    </div>
                <div className="flex flex-col md:flex-row justify-center flex-wrap gap-6">
                        {items.map((item, index) => {
                            console.log(item.video_id)
                            return (
                                <div key={index} className="card relative w-full md:w-1/3 justify-start">
                                    
                                    <div className="relative hidden md:block">
                                        <VideoModal src={item.video_id} />
                                        <GatsbyImage image={getImage(item.image)} alt={item.image.alt} className="rounded-t-2xl" />
                                    </div>
                                    
                                    <div className="video-wrapper block lg:hidden">
                                        <iframe
                                        src={"https://player.vimeo.com/video/" + item.video_id}
                                        frameBorder="0"
                                        allow="autoplay; fullscreen; picture-in-picture"
                                        title={item.caption}
                                        />
                                    </div>
                                    <div className="relative py-3 px-6"><p className="text-sm text-center mb-0">{item.caption}</p></div>
                                    
                                </div>
                            )
                        })}
                </div>
                
            </div>
        </section>
    );
}

